export default "__VITE_ASSET__CNJogV7c__"